import React from 'react';
import type { TextV2Props } from '@withjoy/joykit';
import { TextV2 } from '@withjoy/joykit';

const AI_TEXT_GRADIENT = 'linear-gradient(91deg, #25AFFA 1.23%, #4951EF 46.08%, #CE54B3 83.79%)';

const GRADIENT_STYLE = {
  background: AI_TEXT_GRADIENT,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
} as const;

type AiGradientTextProps = Readonly<TextV2Props & { children: React.ReactNode }>;

export const AiGradientText: React.FC<AiGradientTextProps> = ({ children, ...textProps }) => (
  <TextV2
    typographyVariant="button1"
    fontWeight="medium"
    {...textProps}
    style={{ ...GRADIENT_STYLE, ...textProps.style }}
  >
    {children}
  </TextV2>
);
